import { useState, useEffect } from "react";

import DataProcessingReport from "./reports/dataProcessingReport/dataProcessingReport";

import "./dataQualityDashboard.scss";
import FileTrackingReport from "../fileTrackingReport/fileTrackingReport";

const DataQualityDashboard = () => {

    
  const DATA_PROCESSING_REPORT = { value: "dataProcessingReport", component: <DataProcessingReport />, label: "Data Processing Pipeline Dashboard" };
  const FILE_TRACKING_REPORT = { value: "file_tracking_report", component: <FileTrackingReport />, label: "File Tracking Dashboard" };

    const [selectedReport, setSelectedReport] = useState("dataProcessingReport");

  return (
    <div className="dataQualityDashboard">
      <div className="dataQualityDashboard__header">
        <div className="dataQualityDashboard__header__description">
            <div className="dataQualityDashboard__header__description__title">{selectedReport==="file_tracking_report" ? FILE_TRACKING_REPORT?.label : DATA_PROCESSING_REPORT?.label}</div>
            <div className="dataQualityDashboard__header__description__route">Reports / <span className="dataQualityDashboard__header__description__route__active">{selectedReport==="file_tracking_report" ? FILE_TRACKING_REPORT?.label : DATA_PROCESSING_REPORT?.label }</span></div>
        </div>
        {/* <div className="dataQualityDashboard__header__report-navigation">
            <div className="dataQualityDashboard__header__report-navigation__button">
                <div className={`dataQualityDashboard__header__report-navigation__button__report-1 ${selectedReport === "dataProcessingReport" ? "active" : ""}`}>Data Processing Pipeline</div>
            </div>
        </div> */}
        <div className="dataQualityDashboard__header__report-switch-button" onClick={()=>setSelectedReport(selectedReport==="file_tracking_report" ? DATA_PROCESSING_REPORT?.value : FILE_TRACKING_REPORT?.value)}>
          {selectedReport==="file_tracking_report" ? DATA_PROCESSING_REPORT?.label : FILE_TRACKING_REPORT?.label}
        </div>
      </div>
      <div className="dataQualityDashboard__body">
        {selectedReport==="file_tracking_report" ? FILE_TRACKING_REPORT?.component : DATA_PROCESSING_REPORT?.component}
      </div>
    </div>
  );
};

export default DataQualityDashboard;
